import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { NotExecutedHistoryItem } from 'src/app/model/history-item/not-executed-history-item';
import { DeserializeVoid, _post } from '../../base.service';
import { LoadingService } from '../../loading.service';
import { SnackService } from '../../snack.service';

@Injectable({
  providedIn: 'root',
})
export class EditNotExecutedHistoryItemControllerRequestService {
  private static BASE_URL = '/immo/editNotExecutedHistoryItem';
  private readonly post: <T>(
    path: string,
    body: RequestBody,
    deserialize: (response: any) => T
  ) => Observable<T>;
  constructor(
    http: HttpClient,
    snackService: SnackService,
    loadingService: LoadingService,
    router: Router
  ) {
    const requestServices = {
      http,
      loadingService,
      router,
      snackService,
    };
    this.post = _post(
      EditNotExecutedHistoryItemControllerRequestService.BASE_URL,
      requestServices
    );
  }

  public editNotExecutedHistoryItem(
    notExecutedHistoryItem: NotExecutedHistoryItem
  ): Promise<void> {
    const requestBody: RequestBody = {
      id: notExecutedHistoryItem.id,
      content: notExecutedHistoryItem.content,
      callClient: notExecutedHistoryItem.callClient,
      clientCommunicationSummary:
        notExecutedHistoryItem.clientCommunicationSummary,
      callInpress: notExecutedHistoryItem.callInpress,
      inpressCommunicationSummary:
        notExecutedHistoryItem.inpressCommunicationSummary,
      suggestedFollowUp: notExecutedHistoryItem.suggestedFollowUp,
      stockAtBranchId:
        notExecutedHistoryItem.stockAtBranch == null
          ? null
          : notExecutedHistoryItem.stockAtBranch.id,
      onlineInfo: notExecutedHistoryItem.onlineInfo,
    };
    return this.post('', requestBody, DeserializeVoid).toPromise();
  }
}

type RequestBody = {
  id: number;
  content: string;
  callClient: boolean;
  clientCommunicationSummary: string;
  callInpress: boolean;
  inpressCommunicationSummary: string;
  suggestedFollowUp: string;
  stockAtBranchId: number;
  onlineInfo: string;
};
